var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.completedTransfer
    ? _c("v-layout", { staticClass: "wallet-box" }, [
        _c("div", { staticClass: "icon-message" }, [
          _c("img", { attrs: { src: _vm.transferResultImage } })
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "success-message" }, [
          _vm._v(_vm._s(_vm.transferResultMessage))
        ])
      ])
    : _vm.professional.account.payment_gateway_account &&
      _vm.professional.account.payment_gateway_account.wallet.id
    ? _c("Wallet", {
        key: _vm.walletKeyComponent,
        attrs: {
          preloader: _vm.preloader,
          walletId: this.professional.account.payment_gateway_account.wallet.id,
          withDraw: true,
          owner: this.professional
        },
        on: { requestWithdraw: _vm.requestWithDraw }
      })
    : _c("div", [
        _vm._v("\n  Carteira do profissional ainda não foi criada.\n")
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22dd2df8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22dd2df8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Professionals/Edit/Tabs/Wallet.vue
// module id = null
// module chunks = 